import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

export default function Analytics() {
  const location = useLocation();

  useEffect(() => {
    const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;
    
    // Only initialize if the measurement ID is provided and we are not in development
    // (You can remove the dev check if you want to test in localhost)
    if (measurementId && import.meta.env.PROD) {
       // Initialize GA4
       ReactGA.initialize(measurementId, { gtagOptions: { send_page_view: false, page_location: window.location.origin + window.location.pathname, page_referrer: window.location.origin } });
    }
  }, []);

  useEffect(() => {
    const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;
    
    // Send a pageview event whenever the route changes
    if (measurementId && import.meta.env.PROD) {
      // Account verification and team invitations contain secrets in their query strings.
      ReactGA.set({ page_location: window.location.origin + location.pathname, page_referrer: window.location.origin });
      ReactGA.send({ hitType: "pageview", page: location.pathname });
    }
  }, [location]);

  return null;
}
